import { Stack } from "expo-router";
import { ensureStackAnchorListeners } from "@utils/navigation/ensureStackAnchor";
import { ComponentProps } from "react";

type StackScreenOptions = NonNullable<
  ComponentProps<typeof Stack.Screen>["options"]
>;

export const unstable_settings = {
  initialRouteName: "you",
};

const defaultScreenOptions = (
  options?: StackScreenOptions,
): StackScreenOptions => {
  return {
    ...options,
    animation: "default",
    headerShown: false,
  };
};

const AccountStack = () => {
  return (
    <Stack
      screenOptions={{
        ...defaultScreenOptions(),
        contentStyle: { backgroundColor: "transparent" },
        animation: "none",
      }}
      screenListeners={ensureStackAnchorListeners("you")}
    >
      <Stack.Screen name="index" />
      <Stack.Screen name="you" />
      <Stack.Screen name="settings" options={defaultScreenOptions()} />
      <Stack.Screen name="edit" options={defaultScreenOptions()} />
      <Stack.Screen name="artist/settings" options={defaultScreenOptions()} />
      <Stack.Screen name="artist/profile" options={defaultScreenOptions()} />
      <Stack.Screen
        name="[collectionType]/[collectionId]/index"
        options={defaultScreenOptions()}
        getId={({ params }) =>
          `${params?.collectionType}/${params?.collectionId}`
        }
      />
      <Stack.Screen name="artist/[artistId]" options={defaultScreenOptions()} />
      <Stack.Screen name="wallet" />
    </Stack>
  );
};

export default AccountStack;
